export default __webpack_public_path__ + "25b3f136c151dcc5b386d098356b6f82.svg";